/**
 * @generated SignedSource<<74c82a7a1d3cb464756fc6301a73a042>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Timeline_meetingKeyEvents$data = {
  readonly comments: ReadonlyArray<{
    readonly startTimestamp: string;
    readonly threadId: number;
  }>;
  readonly meetingKeyEvents: ReadonlyArray<{
    readonly duration: number | null;
    readonly endTimeFromRecordingStart: number | null;
    readonly eventType: string;
    readonly participantName: string | null;
    readonly timeFromRecordingStart: number;
  }> | null;
  readonly " $fragmentType": "Timeline_meetingKeyEvents";
};
export type Timeline_meetingKeyEvents$key = {
  readonly " $data"?: Timeline_meetingKeyEvents$data;
  readonly " $fragmentSpreads": FragmentRefs<"Timeline_meetingKeyEvents">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Timeline_meetingKeyEvents",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingKeyEvent",
      "kind": "LinkedField",
      "name": "meetingKeyEvents",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "participantName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeFromRecordingStart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endTimeFromRecordingStart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "duration",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecordingCommentsData",
      "kind": "LinkedField",
      "name": "comments",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "threadId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startTimestamp",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MeetingRecording",
  "abstractKey": null
};

(node as any).hash = "9fbd637ef5feed713d9b5874931a35cf";

export default node;
